// extracted by mini-css-extract-plugin
export default {"table":"Table_table__xOvQa","empty":"Table_empty__7goNT","striped":"Table_striped__u4TgW","hoverable":"Table_hoverable__RHe21","compact":"Table_compact__Bp2PG"};